import { TransactionTypeChar } from '../Transaction/Transaction';

type TranTypeReason = {
    [key in TransactionTypeChar]?: boolean;
};

export interface DeclineReason extends TranTypeReason {
    code: string;
    numericCode?: number;
    reason: string;
    collateral?: boolean;
}

const allDeclineReasons: DeclineReason[] = [
    {
        code: 'A',
        reason: 'Incorrect Amount',
        [TransactionTypeChar.deposit]: true,
        [TransactionTypeChar.send]: true,
        [TransactionTypeChar.order]: true,
        [TransactionTypeChar.withdrawal]: true,
        collateral: true
    },
    {
        code: 'B',
        reason: 'Incorrect Recipient',
        [TransactionTypeChar.deposit]: false,
        [TransactionTypeChar.send]: false,
        [TransactionTypeChar.order]: false,
        [TransactionTypeChar.withdrawal]: false,
        collateral: true
    },
    {
        code: 'C',
        reason: 'Incorrect Public Description',
        [TransactionTypeChar.deposit]: false,
        [TransactionTypeChar.send]: false,
        [TransactionTypeChar.order]: false,
        [TransactionTypeChar.withdrawal]: false,
        collateral: false
    },
    {
        code: 'D',
        reason: 'Incorrect Private Description',
        [TransactionTypeChar.deposit]: false,
        [TransactionTypeChar.send]: false,
        [TransactionTypeChar.order]: false,
        [TransactionTypeChar.withdrawal]: false,
        collateral: false
    },
    {
        code: 'E',
        reason: 'Insufficient Funds in Account',
        [TransactionTypeChar.deposit]: true,
        [TransactionTypeChar.send]: true,
        [TransactionTypeChar.order]: true,
        [TransactionTypeChar.withdrawal]: true,
        collateral: true
    },
    {
        code: 'F',
        reason: 'Associated Bank Account has an Abnormal Status',
        [TransactionTypeChar.deposit]: false,
        [TransactionTypeChar.send]: false,
        [TransactionTypeChar.order]: false,
        [TransactionTypeChar.withdrawal]: false,
        collateral: false
    },
    {
        code: 'G',
        reason: 'Service Unavailable. Please Try Again Later',
        [TransactionTypeChar.deposit]: false,
        [TransactionTypeChar.send]: false,
        [TransactionTypeChar.order]: false,
        [TransactionTypeChar.withdrawal]: false,
        collateral: false
    },
    {
        code: 'H',
        reason: 'No Longer Required',
        [TransactionTypeChar.deposit]: true,
        [TransactionTypeChar.send]: true,
        [TransactionTypeChar.order]: true,
        [TransactionTypeChar.withdrawal]: true,
        collateral: true
    },
    {
        code: 'I',
        reason: 'Insufficient Funds in Associated Bank Account',
        [TransactionTypeChar.deposit]: false,
        [TransactionTypeChar.send]: false,
        [TransactionTypeChar.order]: false,
        [TransactionTypeChar.withdrawal]: false,
        collateral: false
    },
    {
        code: 'J',
        reason: 'Incorrect Contract Type',
        [TransactionTypeChar.deposit]: false,
        [TransactionTypeChar.send]: false,
        [TransactionTypeChar.order]: false,
        [TransactionTypeChar.withdrawal]: false,
        collateral: false
    },
    {
        code: 'K',
        reason: 'Incorrect Pay Period',
        [TransactionTypeChar.deposit]: false,
        [TransactionTypeChar.send]: false,
        [TransactionTypeChar.order]: false,
        [TransactionTypeChar.withdrawal]: false,
        collateral: false
    },
    {
        code: 'L',
        reason: 'Incorrect Frequency Type',
        [TransactionTypeChar.deposit]: false,
        [TransactionTypeChar.send]: false,
        [TransactionTypeChar.order]: false,
        [TransactionTypeChar.withdrawal]: false,
        collateral: false
    },
    {
        code: 'M',
        reason: 'Price Change',
        [TransactionTypeChar.deposit]: true,
        [TransactionTypeChar.send]: true,
        [TransactionTypeChar.order]: true,
        [TransactionTypeChar.withdrawal]: true,
        collateral: false
    },
    {
        code: 'T',
        reason: 'Insufficient Tokens',
        [TransactionTypeChar.deposit]: false,
        [TransactionTypeChar.send]: false,
        [TransactionTypeChar.order]: false,
        [TransactionTypeChar.withdrawal]: false,
        collateral: false
    },
    {
        code: '127',
        numericCode: 127,
        reason: 'Prior Deposit Request for DDA in progress, please try later',
        [TransactionTypeChar.deposit]: false,
        [TransactionTypeChar.send]: false,
        [TransactionTypeChar.order]: false,
        [TransactionTypeChar.withdrawal]: false,
        collateral: false
    }
];

export const getDeclineReasons = (transactionType: TransactionTypeChar): { code: string; reason: string }[] => {
    const type = transactionType === TransactionTypeChar.receive ||
        transactionType === TransactionTypeChar.transfer ?
        TransactionTypeChar.send
        : transactionType;

    return allDeclineReasons.filter((declineReason) => declineReason[type]);
};

export const getPledgeDeclineReasons = (): { code: string, reason: string }[] => (
    allDeclineReasons.filter((declineReason) => declineReason.collateral)
);

export enum DeclineReasonCodeEnum {
    NONE = 0,
    SUCCESS = 32,
    INC_AMOUNT = 65,
    INC_RECIPIENT = 66,
    INC_PUB_DESC = 67,
    INC_PRIV_DESC = 68,
    INSUFF_ACCOUNT_FUNDS = 73,
    ABNORMAL_ACCOUNT = 70,
    NO_LONGER_REEQUIRED = 72,
    INSUFF_WALLET_FUNDS = 69,
    INC_CONTRACT_TYPE = 74,
    INC_PAY_PERIOD = 75,
    INC_FREQUENCY_TYPE = 76,
    SERVICE_UNAVAILABLE = 71,
    INSUFF_TOKENS = 84,
    PRIOR_DDA_REQUEST_IN_PROGRESS = 127,
    PRICE_CHANGE = 77
}

export enum DeclineReasonCharEnum {
    NO_LONGER_REQUIRED = 'H'
}

export default allDeclineReasons;